"use client"

import { CalendarMinus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CalendarMinusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CalendarMinusIcon = component(Icon)({ as: CalendarMinus })
